import React from "react";
import { InclusionSection } from "./InclusionSection";
import { ExclusionSection } from "./ExclusionSection";
import { useVendorSections } from "./useVendorSections";
import { useInsideFilterChip } from "../../../../pages/Workspace/UserFilters/FiltersChips/hooks/useInsideFilterChip";
import { FilterLayout } from "../FilterLayout";

export const VendorsFilter = React.memo(() => {
  const { insideChip, elementRef } = useInsideFilterChip();
  const {
    inclusionCondition,
    inclusionVendorIds,
    inclusionFaiIds,
    inclusionInstallAgeMonths,
    inclusionProductCount,
    exclusionVendorIds,
    handleInclusionVendorSelect,
    handleExclusionVendorSelect,
    handleConditionChange,
    handleClearFilter,
    handleFaiSelect,
    handleInstallAgeChange,
    handleProductCountChange,
  } = useVendorSections();

  return (
    <FilterLayout
      title="Vendors"
      id="vendors-filter"
      onClear={handleClearFilter}
      showHeader={!insideChip}
      refProp={elementRef}
    >
      {/* Inclusion Section */}
      <InclusionSection
        condition={inclusionCondition}
        selectedVendorIds={inclusionVendorIds}
        onConditionChange={handleConditionChange}
        onVendorSelect={handleInclusionVendorSelect}
        selectedFaiIds={inclusionFaiIds}
        onFaiSelect={handleFaiSelect}
        installAgeMonths={inclusionInstallAgeMonths}
        onInstallAgeChange={handleInstallAgeChange}
        productCount={{
          min: inclusionProductCount?.min ?? undefined,
          max: inclusionProductCount?.max ?? undefined,
        }}
        onProductCountChange={handleProductCountChange}
      />

      {/* Exclusion Section */}
      <ExclusionSection
        selectedVendorIds={exclusionVendorIds}
        onVendorSelect={handleExclusionVendorSelect}
      />
    </FilterLayout>
  );
});
